import { useState, useRef } from "react";
import { API } from "@/lib/api";
import api, { apiErr } from "@/lib/api";
import { toast } from "sonner";
import { Camera, X, Loader2 } from "lucide-react";

export default function PhotoUploader({ value = [], onChange, testId }) {
  const [busy, setBusy] = useState(false);
  const ref = useRef();

  const onSelect = async (e) => {
    const files = Array.from(e.target.files || []);
    if (!files.length) return;
    setBusy(true);
    try {
      const paths = [];
      for (const f of files) {
        const fd = new FormData();
        fd.append("file", f);
        const { data } = await api.post("/upload", fd, { headers: { "Content-Type": "multipart/form-data" } });
        paths.push(data.path);
      }
      onChange([...(value || []), ...paths]);
      toast.success(`${paths.length} photo(s) ajoutée(s)`);
    } catch (err) { toast.error(apiErr(err.response?.data?.detail)); }
    finally { setBusy(false); if (ref.current) ref.current.value = ""; }
  };

  const remove = (p) => onChange(value.filter((x) => x !== p));

  return (
    <div>
      <div className="flex flex-wrap gap-2 mb-2">
        {(value || []).map((p) => (
          <div key={p} className="relative w-16 h-16 rounded-lg overflow-hidden border border-[#E2E8F0]">
            <img src={`${API}/files/${p}`} alt="état" className="w-full h-full object-cover" />
            <button type="button" onClick={() => remove(p)} className="absolute top-0.5 right-0.5 bg-[#B91C1C] text-white rounded-full p-0.5"><X className="w-3 h-3" /></button>
          </div>
        ))}
      </div>
      <input ref={ref} type="file" accept="image/*" capture="environment" multiple className="hidden" onChange={onSelect} data-testid={testId ? `${testId}-input` : "photo-input"} />
      <button type="button" onClick={() => ref.current?.click()} disabled={busy} className="btn-outline !py-1.5 text-xs" data-testid={testId || "photo-upload-btn"}>
        {busy ? <Loader2 className="w-3.5 h-3.5 animate-spin" /> : <Camera className="w-3.5 h-3.5" />} Ajouter une photo
      </button>
    </div>
  );
}
